var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 3.2274C12.3927 3.05548 12.5913 2.91835 12.8109 2.82402C13.0305 2.72968 13.2667 2.68002 13.5057 2.67795C13.7447 2.67587 13.9817 2.72141 14.2029 2.81192C14.4241 2.90242 14.6251 3.03608 14.7941 3.20509C14.9631 3.37409 15.0968 3.57507 15.1873 3.79628C15.2778 4.01749 15.3233 4.25452 15.3213 4.49352C15.3192 4.73252 15.2695 4.96872 15.1752 5.18833C15.0809 5.40793 14.9437 5.60655 14.7718 5.7726L14.0581 6.4863L11.5129 3.9411L12.2266 3.2274V3.2274ZM10.2403 5.2137L2.69922 12.7548V15.3H5.24442L12.7864 7.7589L10.2394 5.2137H10.2403Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Pencil.7952ed97eeef69532678ec72f5e0357f.svg";